import {
  AMOUNT_PER_GUEST_MIN,
  MIN_PERSONS,
} from '../../../widgets/prepaySettingsForm/lib/constants';
import { PrepaySettings, PrepaySettingsDTO, PrepayNotificationDTO } from './types';

const findNotification = (
  notifications: PrepayNotificationDTO[],
  type: PrepayNotificationDTO['type'],
): PrepayNotificationDTO | undefined => notifications.find((n) => n.type === type);

export const mapDTOToDomain = (dto: PrepaySettingsDTO): PrepaySettings => {
  const prepayRequired = findNotification(dto.notifications, 'PREPAYMENT_REQUIRED');
  const prepayReminder = findNotification(dto.notifications, 'PREPAYMENT_REMINDER');
  const prepayCancelled = findNotification(dto.notifications, 'PREPAYMENT_CANCELLED');

  return {
    isEnabled: dto.isEnabled,
    paymentBank: dto.paymentBank,
    prepayAmountMode: dto.prepayAmountMode,
    widgetMessage: dto.widgetMessage,
    widgetMessageAuto: dto.widgetMessageAuto,
    amountPerPerson: dto.amountPerPerson ?? AMOUNT_PER_GUEST_MIN,
    minPersons: dto.minPersons ?? MIN_PERSONS,
    reminder: {
      isEnabled: dto.reminder.isEnabled,
      delayMinutes: dto.reminder.delayMinutes,
    },
    autoCancel: {
      isEnabled: dto.autoCancel.isEnabled,
      delayMinutes: dto.autoCancel.delayMinutes,
    },
    notifications: {
      prepayRequired: {
        type: 'PREPAYMENT_REQUIRED',
        isEnabled: prepayRequired?.isEnabled ?? false,
        template: prepayRequired?.template ?? '',
      },
      prepayReminder: {
        type: 'PREPAYMENT_REMINDER',
        isEnabled: prepayReminder?.isEnabled ?? false,
        template: prepayReminder?.template ?? '',
      },
      prepayCancelled: {
        type: 'PREPAYMENT_CANCELLED',
        isEnabled: prepayCancelled?.isEnabled ?? false,
        template: prepayCancelled?.template ?? '',
      },
    },
  };
};

export const mapDomainToDTO = (domain: PrepaySettings): PrepaySettingsDTO => ({
  isEnabled: domain.isEnabled,
  paymentBank: domain.paymentBank,
  prepayAmountMode: domain.prepayAmountMode,
  widgetMessage: domain.widgetMessage,
  widgetMessageAuto: domain.widgetMessageAuto,
  amountPerPerson: domain.amountPerPerson,
  minPersons: domain.minPersons,
  reminder: {
    isEnabled: domain.reminder.isEnabled,
    delayMinutes: domain.reminder.delayMinutes,
  },
  autoCancel: {
    isEnabled: domain.autoCancel.isEnabled,
    delayMinutes: domain.autoCancel.delayMinutes,
  },
  notifications: [
    domain.notifications.prepayRequired,
    domain.notifications.prepayReminder,
    domain.notifications.prepayCancelled,
  ],
});
